import { Directive, Input, EventEmitter, Output, HostListener, HostBinding } from "@angular/core";

export type SortDirection = "asc" | "desc" | "";
export const compare = (v1, v2): number => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

export interface SortEvent {
    column: string;
    direction: SortDirection;
}

const rotate: {[key: string]: SortDirection} = { asc: "desc", desc: "", "": "asc" };

@Directive({
    selector: "[appSortable]"
})
export class NgbdSortableHeaderDirective {
    @Input() appSortable: string;
    @Input() direction: SortDirection = "";
    @Output() sort = new EventEmitter<SortEvent>();


    @HostListener("click")
    public rotate(): void {
        this.direction = rotate[this.direction];
        this.sort.emit({column: this.appSortable, direction: this.direction});
    }
    @HostBinding("class.asc")
    public get esAscendente() {
        return this.direction === "asc";
    }
    
    @HostBinding("class.desc")
    public get esDescendente() {
        return this.direction === "desc";
    }
}
